import Box from "@mui/material/Box";
import Button from "../Button/Button";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import React from "react";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import { headerBreakpointConfig } from "./Header";
import { useTheme } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import { format, isDefined, isObject, useBreakpoint } from "@pheaa/channels-component-library";


const ProfilePopover = ({ bypassPopover = false, handleSignOut, icon, isPendingSessionEnd, profileData, text, to, textWrap = true }) => {
	const [anchorEl, setAnchorEl] = React.useState(null);

	const handleClick = (event) => {
		setAnchorEl(anchorEl ? null : event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const breakpoint = useBreakpoint(headerBreakpointConfig);
	const open = Boolean(anchorEl);
	const id = open ? "simple-popper" : undefined;
	const theme = useTheme();

	return (
		<div>
			<Box
				aria-describedby={id}
				className="cmp-header__link"
				component={bypassPopover ? NavLink : "button"}
				onClick={handleClick}
				sx={{
					background: "none",
					border: "none",
					display: "block",
					margin: 0,
					paddingX: 2,
					paddingY: 0,
					position: "relative"
				}}
				to={bypassPopover ? to : null}
				type={bypassPopover ? null : "button"}
			>
				<Box className="cmp-header__link-box" data-icon={isDefined(icon) ? true : null}>
					<Box
						sx={{
							alignItems: "center",
							color: theme.palette.primary.contrastText,
							display: "flex",
							flexDirection: "column",
							fontFamily: theme.typography.fontFamily,
							fontSize: 10,
							fontWeight: 600,
							justifyContent: "center",
							minHeight: 85
						}}
					>
						{icon}
						<span className="cmp-header__link-text" style={!textWrap ? { whiteSpace: "nowrap" } : null}>
							{text}
						</span>
					</Box>
				</Box>
			</Box>
			{breakpoint.key !== "medium" && <Popover
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				id={id}
				onClose={handleClose}
				open={open}
				slotProps={{
					paper: {
						sx: {
							overflow: "visible",
							p: 2,
							position: "relative",
							width: "300px",
							"&:before": {
								content: "\"\"",
								border: "0.8rem solid transparent",
								borderBottomColor: "white",
								borderTopWidth: 0,
								position: "absolute",
								right: { xs: "3.2rem", sm: "4rem" },
								top: "-0.8rem",
							}
						}
					}
				}}
			>
				<IconButton
					align="right"
					color="primary"
					onClick={handleClose}
					sx={{ top: 0, right: 0, position: "absolute" }}
				>
					<CloseIcon fontSize="medium" />
				</IconButton>
				<Typography sx={{ fontSize: "2.4rem" }}>
					{isObject(profileData) && isObject(profileData.iam) && isObject(profileData.iam.name) && format.asProperName(profileData.iam.name)}
				</Typography>
				<Divider sx={{ borderColor: theme.palette.divider, mt: 1.75 }} />
				<Button component={Link} size="small" sx={{ width: "100%" }} to="/profile">
					Contact Information
				</Button>
				<Divider sx={{ borderColor: theme.palette.divider }} />
				<Box mt={2.5}>
					<Button
						disabled={isPendingSessionEnd}
						onClick={handleSignOut}
						type="button"
						sx={{ width: "100%" }}
						variant="contained"
					>
						Sign Out
					</Button>
				</Box>
			</Popover>}
		</div >
	);
};

const mapStateToProps = state => {
	return {
		isPendingSessionEnd: state.auth.isPendingSessionEnd,
		profileData: state.profile.data
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePopover);